import { render, staticRenderFns } from "./PortionsGroup.vue?vue&type=template&id=4899aa42&scoped=true&"
import script from "./PortionsGroup.vue?vue&type=script&lang=js&"
export * from "./PortionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./PortionsGroup.vue?vue&type=style&index=0&id=4899aa42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899aa42",
  null
  
)

export default component.exports